import { i18n } from '@/locales';
export default {
    CASH: {
        text: i18n.t('common.delivery_pay_type.pay_cash'),
        color: 'green',
        value: 'CASH',
    },
    BAROMONEY: {
        text: i18n.t('common.delivery_pay_type.pay_baromoney'),
        color: 'blue',
        value: 'BAROMONEY',
    },
};
